import { useGetPhysicalCargoSourcesQuery } from '../../store/api/routesApi';
import type { PhysicalCargoSourcesQueryArgs } from '../../types/physicalCargoSource';

export function usePhysicalCargoSourcesQuery(
  args: PhysicalCargoSourcesQueryArgs & { skip?: boolean }
) {
  const { skip, applicationId, excludeRouteId, routeId } = args;
  const appId = Number(applicationId);
  return useGetPhysicalCargoSourcesQuery(
    {
      applicationId: appId,
      excludeRouteId,
      routeId
    },
    {
      skip: Boolean(skip) || !Number.isFinite(appId) || appId <= 0
    }
  );
}
